<template>
	<div class="">
		<!-- <sf-button line v-if="isButton_(scrId, 'AD')" icon="file" :onClick="() => onClickButton('save')">{{
			getMessage_('MWCC000138')
		}}</sf-button> -->

		<!-- 저장 -->
		<sf-button v-if="isButton_(scrId, 'CU') && btnChk1" line size="lg" icon="file" :onClick="saveAction">
			{{ getMessage_('MWCC000327') }}
		</sf-button>
		<!-- 재검사 -->
		<sf-button v-if="isButton_(scrId, 'RI') && btnChk5" line size="lg" icon="download" :onClick="reInspectionPopup">
			{{ getMessage_('QWCC000054') }}
		</sf-button>
		<!-- 검사완료 -->
		<sf-button v-if="isButton_(scrId, 'IC') && btnChk1" line size="lg" icon="round-check-on" :onClick="() => savePgsStAction('20')">
			{{ getMessage_('QWCC000055') }}
		</sf-button>

		<!-- 검토(검토자) -->
		<sf-button v-if="isButton_(scrId, 'IP') && btnChk2" line size="lg" icon="round-check-on" :onClick="() => savePgsStAction('40')">
			{{ getMessage_('QWCC001132') }}
		</sf-button>
		<!-- 승인(승인자) -->
		<sf-button v-if="isButton_(scrId, 'CS') && btnChk3" line size="lg" icon="round-check-on" :onClick="() => savePgsStAction('50')">
			{{ getMessage_('QWCC001001') }}
		</sf-button>
		<!-- 반려(검토자) -->
		<sf-button v-if="isButton_(scrId, 'GV') && btnChk4" line size="lg" icon="circle-close" :onClick="() => savePgsStAction('30')">
			{{ getMessage_('QWCC001003') }}
		</sf-button>
		<!-- 부품검사 항목 공통코드 팝업 버튼 -->
		<sf-button v-if="isButton_(scrId, 'CR')" line icon="search" :onClick="onPartCommPopup">
			{{ getMessage_('QWCC001846') }}
		</sf-button>
		<!--부품검사 항목정보 공통코드 팝업창 -->
		<part-comm-poupup ref="partCommPoupup" :scrId="scrId" />
		<!--부품검사 재검사 팝업창 -->
		<part-re-ins-popup-content ref="PartReInsPopupContent" :scrId="scrId" @RefreshReIns="refreshReIns" />
	</div>
</template>

<script>
import * as yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import { qmsComputed, qmsMethods } from '@/store/qms/helpers';
import PartCommPoupup from '@qms/pqy/pcku/PartCku/Content/Popup/PartPopupCommContent.vue';
import PartReInsPopupContent from '@qms/pqy/pcku/PartCku/Content/Popup/PartReInsPopupContent.vue';

export default {
	props: {
		scrId: { type: String, default: '' },
		flgOsGrp: { type: Boolean, default: false },
		flgPqyapGrp: { type: Boolean, default: false },
		flgPqyrvGrp: { type: Boolean, default: false },
		flgPqyrgGrp: { type: Boolean, default: false }
	},
	data() {
		return {
			flgOs: this.flgOsGrp, //시스템관리자
			flgPqyap: this.flgPqyapGrp, //관리자(승인)
			flgPqyrv: this.flgPqyrvGrp, //중간관리자(검토)
			flgPqyrg: this.flgPqyrgGrp //업무담당자(작성)
		};
	},
	async created() {
		//console.log('LeftButtons flgOs >>>' + this.flgOs);
		//console.log('LeftButtons flgPqyap >>>' + this.flgPqyap);
		//console.log('LeftButtons flgPqyrv >>>' + this.flgPqyrv);
		//console.log('LeftButtons flgPqyrg >>>' + this.flgPqyrg);
		//console.log('LeftButtons pgsStCd >>>' + this.formInfo.pgsStCd);
	},
	components: {
		PartCommPoupup,
		PartReInsPopupContent
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		...qmsComputed,
		btnChk1() {
			// 저장버튼 제어
			let pass = false;

			if (
				this.formInfo.pgsStCd === undefined ||
				this.formInfo.pgsStCd === '' ||
				this.formInfo.pgsStCd === null ||
				Number(this.formInfo.pgsStCd) === 10 ||
				Number(this.formInfo.pgsStCd) === 30
			) {
				pass = true;
			}
			//console.log('btnChk1 this.formInfo.pgsStCd  , pass >>>', Number(this.formInfo.pgsStCd), pass);
			return pass;
		},
		btnChk2() {
			let pass = false;
			if (this.formInfo.pgsStCd !== undefined && Number(this.formInfo.pgsStCd) === 20) {
				pass = true;
			}
			// 검토버튼 제어
			//console.log('btnChk2 !undefined or 검사완료(20)>>>', this.formInfo.pgsStCd !== undefined, Number(this.formInfo.pgsStCd) === 20);
			return pass;
		},
		btnChk3() {
			//승인버튼 제어
			let pass = false;
			if (this.formInfo.pgsStCd !== undefined && Number(this.formInfo.pgsStCd) === 40) {
				pass = true;
			}
			//console.log('btnChk3 >>>', this.formInfo.pgsStCd !== undefined || Number(this.formInfo.pgsStCd) === 40);
			//console.log('btnChk3 !undefined or 작성완료(40)>>>', this.formInfo.pgsStCd !== undefined, Number(this.formInfo.pgsStCd) === 40);
			return pass;
		},
		btnChk4() {
			//반려버튼 제어
			let pass = false;
			//상태가 검사완료(20)일 경우 반려버튼이 보여진다.

			if (this.flgPqyrv) {
				//검토자그룹
				if (Number(this.formInfo.pgsStCd) === 20) {
					// 검사완료 상태(20)
					pass = true;
					return pass;
				} else {
					pass = false;
				}
			} else if (this.flgPqyap) {
				//승인자그룹
				if (Number(this.formInfo.pgsStCd) === 40) {
					// 검토완료 상태(40)
					pass = true;
					return pass;
				} else {
					pass = false;
				}
			} else if (this.flgOs) {
				pass = true;
			} else {
				pass = false;
			}
			//console.log('btnChk4_1 검토자(flgPqyrv), 승인자(flgPqyap), pass여부 >>>', this.flgPqyrv, this.flgPqyap, pass);
			return pass;
		},
		btnChk5() {
			//재검사버튼 제어
			let pass = false;
			//반려 또는 OS 일때 재검사 버튼이 보여진다.
			if (Number(this.formInfo.pgsStCd) === 30) {
				pass = true;
			} else if (this.flgOs) {
				pass = true;
			}
			//console.log('btnChk5 반려 or OS >>>', pass, this.formInfo.pgsStCd);
			return pass;
		},
		schema() {
			return yup.object().shape({
				ckuClCd: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000007')])), //{0}은(는) 필수 입력 값 입니다., 검사분류
				//.matches(/^[0-9]{1,2}.[0-9]{1,2}.[0-9]{1,2}$/, this.getMessage_('SWCC000949')), // 버전 양식에 맞게 작성해주세요.
				partClCd: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000069')])), //{0}은(는) 필수 입력 값 입니다. , 유형
				ckuScnCd: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000987')])), //{0}은(는) 필수 입력 값 입니다. , 검사구분
				ckuQty: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000073')])), //{0}은(는) 필수 입력 값 입니다. , 검사수량
				lotFromNo: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001470')])), //{0}은(는) 필수 입력 값 입니다. , lot번호(Fr)
				lotToNo: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001469')])) //{0}은(는) 필수 입력 값 입니다. , lot번호(To)

				// badQty: yup.string().nullable().required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000074')])) //{0}은(는) 필수 입력 값 입니다. , 불량수량
			});
		},
		schemaICSate() {
			return yup.object().shape({
				ckuClCd: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000007')])), //{0}은(는) 필수 입력 값 입니다., 검사분류
				//.matches(/^[0-9]{1,2}.[0-9]{1,2}.[0-9]{1,2}$/, this.getMessage_('SWCC000949')), // 버전 양식에 맞게 작성해주세요.
				partClCd: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000069')])), //{0}은(는) 필수 입력 값 입니다. , 유형
				ckuScnCd: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000987')])), //{0}은(는) 필수 입력 값 입니다. , 검사구분
				ckuQty: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000073')])), //{0}은(는) 필수 입력 값 입니다. , 검사수량
				lotFromNo: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001470')])), //{0}은(는) 필수 입력 값 입니다. , lot번호(Fr)
				lotToNo: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC001469')])), //{0}은(는) 필수 입력 값 입니다. , lot번호(To)

				badQty: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000074')])), //{0}은(는) 필수 입력 값 입니다. , 불량수량

				orderNo: yup
					.string()
					.nullable()
					.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC002081')]))//{0}은(는) 필수 입력 값 입니다. , order No
				
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...qmsMethods,
		saveAction(pgsStCd) {
			try {
				//partNo Validation 처리
				this.makeValidate(pgsStCd);

				// 저장 전 유효성 체크
				this.schema.validateSync(this.formInfo);

				// 저장 전 Grid 유효성 체크
				this.makeValidateGrid(this.resultList);

				let ckuNo = this.searchParams.ckuNo;
				if(ckuNo !== undefined && ckuNo !== ''){
					this.setSearchParam_({key: 'partClCd', value: this.formInfo.partClCd});
				}

				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001119'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001131'), clickFn: () => this.save() }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},
		async save() {
			try {
				this.$sf_toggleLoading(true);

				// 저장시 현재 상태값을 10(검사중)으로 등록
				const pgsData = { key: 'pgsStCd', value: '10' };
				this.onChangeParam_(pgsData);

				//const form = this.formInfo;
				//const params = { partNo, list, form };;

				let formData = new FormData();

				Object.keys(this.formInfo).forEach(key => {
					if (this.formInfo[key]) {
						formData.append(key, this.formInfo[key]);
					}
				});

				const list = this.resultList;
				list.forEach((element, index) => {
					Object.keys(element).forEach(key => {
						if (element[key]) {
							formData.append('list[' + index + '].' + key, element[key]);
						}
					});
				});

				for (const [key, val] of Object.entries(this.formInfo)) {
					if (!val) continue;
					else if (key === 'partCkuFile') {
						val.length ? val.forEach(file => formData.append(key, file)) : formData.append(key, '');
					}
				}

				const { code, messageCd } = await this.savePartCku2_(formData);

				let params = {
					partNo: this.formInfo.partNo,
					ckuNo: this.formInfo.ckuNo
				};
				if (code === 3) {
					this.$sf_toast({
						type: 'error',
						message: this.getMessage_(messageCd)
					});
				} else {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});

					// console.log('여기까지 오는가? >>>', partNo);
					this.$emit('Refresh', params);
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		savePgsStAction(pgsStCd) {
			// 유효성 검사
			// const infoPgsStCd = this.formInfo.pgsStCd;
			// alert(infoPgsStCd);
			// if (pgsStCd == infoPgsStCd) {
			// 	alert('현재 동일한 상태인경우 불가능합니다.');
			// 	return false;
			// }

			try {
				// 유효성 검사
				this.makeValidate(pgsStCd); //재검사 하기전 partNo Validation 처리

				//값 세팅
				this.setStateParam_({ key: 'pgsStCd', value: pgsStCd });

				// console.log('pgsStCd', pgsStCd );
				// console.log('resultList', this.resultList);

				if (pgsStCd !== undefined && pgsStCd === '20') {
					if (this.resultList[0].x1 === undefined || this.resultList[0].x1 === '' || this.resultList[0].x1 === null) {
						throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001391'), ['x1'])); //{0} 열을 모두 입력해주시기 바랍니다.
					}

					if(this.formInfo.partClCd!=='MP'&&this.formInfo.partClCd!=='AS'){
						if (this.resultList[0].x3 !== undefined && this.resultList[0].x3 !== '' && this.resultList[0].x3 !== null) {
						for (let i = 0; i < this.resultList.length; i++) {						
								if(this.resultList[i].comboYn!='Y' && 
								(this.resultList[i].powAbltVal=== null || this.resultList[i].powAbltVal=== undefined || this.resultList[i].powAbltVal=== '') &&
								this.resultList[i].jgmtNm!='미사용'){
									throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC002084'), [this.resultList[i].prvsClNm]));
								}
							}
						}
            		}

					// 저장 전 유효성 체크
					this.schemaICSate.validateSync(this.formInfo);

					// 저장 전 Grid 유효성 체크
					this.makeValidateGrid(this.resultList);

				}

				// 컨펌창 실행
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('QWCC001119'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('QWCC001131'), clickFn: () => this.saveState(pgsStCd) }] //저장
				});
				// }
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async saveState(pgsStCd) {
			this.$sf_toggleLoading(true);
			try {
				const { partNo, ckuNo, affrPrcsId, rmk } = this.formInfo;
				this.setStateParam_({ key: 'partNo', value: partNo });
				this.setStateParam_({ key: 'ckuNo', value: ckuNo });
				this.setStateParam_({ key: 'pgsStCd', value: pgsStCd });
				this.setStateParam_({ key: 'affrPrcsId', value: affrPrcsId });
				this.setStateParam_({ key: 'rmk', value: rmk });

				if (pgsStCd !== undefined && pgsStCd === '20') {
					await this.save();
				}

				const { code, messageCd } = await this.saveState_(this.stateParams);
				let params = {
					partNo: this.formInfo.partNo,
					ckuNo: this.formInfo.ckuNo
				};
				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					this.$emit('Refresh', params);
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		printAction() {},
		reInspectionPopup() {
			let params = {
				partNo: this.formInfo.partNo,
				partNm: this.formInfo.partNm,
				ckuNo: this.formInfo.ckuNo
			};
			let pgsStCd = '';
			try {
				// 유효성 검사
				this.makeValidate(pgsStCd); //재검사 하기전 partNo Validation 처리

				//값 세팅
				//this.setStateParam_({ key: 'pgsStCd', value: pgsStCd });
				this.$refs.PartReInsPopupContent.open(params);
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		// reInspection(pgsStCd) {
		// 	try {
		// 		this.$sf_toggleLoading(true);

		// 		this.makeValidate(pgsStCd); //재검사 하기전 partNo Validation 처리

		// 		// 컨펌창 실행
		// 		this.$sf_showMessage({
		// 			type: 'confirm',
		// 			icon: 'confirm',
		// 			title: this.getMessage_('QWCC001299'), //재검사처리 하시겠습니까?
		// 			buttons: [{ title: this.getMessage_('QWCC000054'), clickFn: () => this.saveReInsp() }] //재검사
		// 		});
		// 	} catch (error) {
		// 		this.$sf_toast({ type: 'error', message: error.message });
		// 	} finally {
		// 		this.$sf_toggleLoading(false);
		// 	}
		// },
		// async saveReInsp() {
		// 	this.$sf_toggleLoading(true);

		// 	try {
		// 		const formData = this.formInfo;
		// 		const { code, messageCd } = await this.saveReInsp_(formData);
		// 		if (code === 0) {
		// 			this.$sf_toast({
		// 				type: code === 0 ? 'ok' : 'error',
		// 				message: this.getMessage_(messageCd)
		// 			});
		// 			this.$emit('Refresh', formData.partNo);
		// 		} else if (code === 3) {
		// 			this.$sf_toast({
		// 				type: code === 0 ? 'ok' : 'error',
		// 				message: this.getMessage_(messageCd)
		// 			});
		// 		}
		// 	} catch (error) {
		// 		this.$sf_toast({ type: 'error', message: error.message });
		// 	} finally {
		// 		this.$sf_toggleLoading(false);
		// 	}
		// },
		makeValidate(pgsStCd) {
			const { partNo, ckuNo, rmk } = this.formInfo;

			if (partNo === undefined || partNo === '') {
				if (ckuNo === undefined || ckuNo === '') {
					throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001300'))); // 조회된 부품번호(품번)가 없습니다.
				}
			}

			if (pgsStCd !== undefined) {
				//반려시 비고란 필수 입력
				if (pgsStCd === '30') {
					if (rmk === '' || rmk === null) {
						throw new TypeError(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('QWCC000906')])); //  //{0}은(는) 필수 입력 값 입니다. , 비고
					}
				}
			}
		},
		makeValidateGrid(resultList) {
			const info = this.formInfo;
			const ckuScnCd = info.ckuScnCd; //검사구분
			const ckuQty = info.ckuQty; //검사수량
			const partClCd = info.partClCd; //검사유형
			const baseXCnt = 10; //x10 까지가 기본
			const baseArr = [10]; //x1 ~ x10 까지의 Row Data값 세팅
			let passYn = 'Y';
			let errColumn = '';
			let fullYn = '';
			let baseArr2 = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0]; //x1 ~ x10 까지 모두 입력했는지 확인하기 위한 배열
			if (Number(ckuQty) > 9999999) {
				throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001397'), [this.getMessage_('QWCC000073'), 10])); //{0}은 최대 {1}까지 입력이 가능합니다.
			}

			if (resultList.length === 0) {
				throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001829'))); //부품검사를 진행하기 위해서는 해당 부품번호에 대한 검사항목부터 설정해 주시기 바랍니다.
			}


			//행 진행
			for (let i = 0; i < resultList.length; i++) {
				//각 Row의 평균, 표준편차, 공정능력값 확인 (콤보박스가 아닌 형태만 진행)
				// if (resultList[i].comboYn !== 'Y') {
				// 	//양산 와 AS가 아닐경우만 체크
				// 	if (!(partClCd === 'MP' || partClCd === 'AS')) {
				// 		const avgValFlag = resultList[i].avgVal === null || resultList[i].avgVal === '';
				// 		const stdDvatValFlag = resultList[i].stdDvatVal === null || resultList[i].stdDvatVal === '';
				// 		const powAbltValFlag = resultList[i].powAbltVal === null || resultList[i].powAbltVal === '';
				// 		if (avgValFlag === true || stdDvatValFlag === true || powAbltValFlag === true) {
				// 			throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001392'))); //평균, 표준편차, 공정능력값을 입력해 주시기 바랍니다.
				// 		}
				// 	}
				// }

				//각 Row의 x1부터 x10까지 입력
				baseArr[0] = resultList[i].x1;
				baseArr[1] = resultList[i].x2;
				baseArr[2] = resultList[i].x3;
				baseArr[3] = resultList[i].x4;
				baseArr[4] = resultList[i].x5;
				baseArr[5] = resultList[i].x6;
				baseArr[6] = resultList[i].x7;
				baseArr[7] = resultList[i].x8;
				baseArr[8] = resultList[i].x9;
				baseArr[9] = resultList[i].x10;

				//열 진행
				for (let j = 0; j < baseXCnt; j++) {
					if (ckuScnCd === 'S') {
						//검사 구분이 Seial 일때 (무조건 x1만 등록되어 있어야 하기때문에 다른쪽에 등록되어 있을경우 체크)
						if (resultList[i].x1 === null || resultList[i].x1 === '') {
							passYn = 'N';
							errColumn = 'x1';
							fullYn = 'N';
							break;
						}
					} else {
						if (baseArr[j] !== null && baseArr[j] !== '') {
							if (j === 0) {
								baseArr2[0] = baseArr2[0] + 1;
							} else if (j === 1) {
								baseArr2[1] = baseArr2[1] + 1;
							} else if (j === 2) {
								baseArr2[2] = baseArr2[2] + 1;
							} else if (j === 3) {
								baseArr2[3] = baseArr2[3] + 1;
							} else if (j === 4) {
								baseArr2[4] = baseArr2[4] + 1;
							} else if (j === 5) {
								baseArr2[5] = baseArr2[5] + 1;
							} else if (j === 6) {
								baseArr2[6] = baseArr2[6] + 1;
							} else if (j === 7) {
								baseArr2[7] = baseArr2[7] + 1;
							} else if (j === 8) {
								baseArr2[8] = baseArr2[8] + 1;
							} else if (j === 9) {
								baseArr2[9] = baseArr2[9] + 1;
							}
						}
					}
				}

				// pass여부
				if (passYn === 'N') {
					break;
				}
			}

			// 1행 부터 n행까지 입력한 데이터의 수가 열마다 전부 입력했는지 확인
			// console.log('baseArr2 resultList.length >>> ', baseArr2, resultList.length);
			for (let p = 0; p < baseArr2.length; p++) {
				if (baseArr2[p] !== 0 && baseArr2[p] < resultList.length) {
					errColumn = 'x' + (p + 1);
					passYn = 'N';
					fullYn = 'N';
					break;
				}
			}

			if (passYn === 'N') {
				throw new TypeError(this.$sf_formatString(this.getMessage_('QWCC001391'), [errColumn])); //{0} 열을 모두 입력해주시기 바랍니다.
			}
		},
		onPartCommPopup() {
			if (this.searchParams.partNo == '') {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC001848') });
			} else {
				this.$refs.partCommPoupup.open(this.searchParams.partNo);
			}
		},
		refreshReIns(params) {
			let returnParam = {
				partNo: params.partNo,
				ckuNo: params.ckuNo
			};
			this.$emit('RefreshReIns', returnParam);
			this.$refs.PartReInsPopupContent.close();
		}
	}
};
</script>

<style lang="scss" scoped></style>
